export default "__VITE_ASSET__Bq5VI$pN__"